/**
 * Created by Tiger on 06/06/2022.
 */
import React, {useState} from "react";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect";
import { getQueryVariable } from "../../common/util";
import useWindowSize from "../../hooks/useWindowSize";
import WebLogin from './web'
import MobileLogin from './mobile'

export default function (props: any) {
  const [isPhone, setIsPhone] = useState(false);
  const {height, width} = useWindowSize();
  const [cid, setCid] = useState(getQueryVariable('login_challenge'));
  useIsomorphicLayoutEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || ''
    setIsPhone(!!userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i));
  }, [height, width]);


  return <>
    {
      isPhone && cid ? <MobileLogin {...props}/> : <WebLogin {...props}/>
    }
  </>;
}
